import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, Grid, Icon, Menu } from 'semantic-ui-react';
import { getAppearanceData } from '../../hooks/useAppearance';
import history from "../../History";

import { SettingsContext } from '../../contexts/SettingsContext';
import AuthContext from '../../contexts/AuthContext';

function LeftDropdown(isAdmin: boolean, isMobile: boolean, helpFileLink:string, auth:any) {

    const renderExtraOptions = () => {
        if (isMobile) {
            let adminElem = null;
            if (isAdmin) {
                adminElem = <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/Admin')}>Admin</Dropdown.Item>
            }
            return (
                <React.Fragment>
                    {adminElem}
                    <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/')}>Home</Dropdown.Item>
                    <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/Themes')}>Themes</Dropdown.Item>
                    <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => history.push('/CM2WebShare/Statistics')}>Statistics</Dropdown.Item>
                    <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => window.open(helpFileLink)}>Help</Dropdown.Item>
                    {auth && auth.userData &&
                        <Dropdown.Item style={{ cursor: 'pointer' }} onClick={() => auth.signOut()}>Log Out</Dropdown.Item>
                    }
                </React.Fragment>
            );
        }
    }

    return (
        <Dropdown.Menu style={{ marginLeft: '-21px' }}>
            {renderExtraOptions()}

        </Dropdown.Menu>
    );
}

function NavMenuBasic() {

    const helpFileLink = "https://helpfiles.fybsoftware.com.au/docs/CM2WebShare-user-manual-61x";

    const { auth } = useContext(AuthContext);

    const { hasAdminPrivileges } = useContext(SettingsContext);

    const [logoImg, setLogoImg] = useState<string>("");
    const [fontColour, setFontColour] = useState<string>("");
    const [bgColour, setBgColour] = useState<string>("");
    

    useEffect(() => {
        async function getData() {
              let data = await getAppearanceData(auth);
  
              if (data) {
                  setLogoImg(data.logo)
                  setFontColour(data.fontColour)
                  setBgColour(data.backgroundColour);
              }
          }
          getData();
    }, [])

    const menuStyle = {
        backgroundColor: bgColour,
        color: fontColour,
        height: "65px",
        position: "relative",
        borderRadius: "0px !important"
    }

    const iconStyle = {
        paddingTop: "3vh",
        padding: "22px",
        paddingLeft: "5px",
        paddingBottom: "43px",
        color: "white",
    };

    const menuItemStyle = {
        color: fontColour
    }

    return (
        <div>
        <Menu className="menu" borderless inverted size='large' id="menu" style={menuStyle}>
            <Grid id="nav-bar">
                <Grid.Row className="computer only row" style={{ display: 'flex' }}>
                    <Menu.Menu position='left' style={{ marginRight: '0px !important', flexGrow: '2', display: 'flex' }}>
                        <Dropdown icon={null} trigger={<Icon link name='content' size='large' style={iconStyle} />}>
                        {LeftDropdown(hasAdminPrivileges, false, helpFileLink, auth)}
                        </Dropdown>
                    </Menu.Menu>

                    <Menu.Menu className="item logo noHover" style={{ position: 'fixed', left: '43%', width: '200px', height: '6vh', padding: '5px', margin: 0 }}>
                        <img src={logoImg} style={{ marginLeft: "auto", marginRight:"auto", display: "block" }}  id="logo" alt='FYB CM2WebShare Logo' />
                    </Menu.Menu>

                    <Menu.Menu position='right' style={{ marginLeft: '0px !important'}}>
                        <Menu.Item
                            name='help'
                            style={menuItemStyle}
                            onClick={() => window.open(helpFileLink)}
                        >
                            Help
                        </Menu.Item>
                    </Menu.Menu>
                </Grid.Row>

                <Grid.Row className="tablet mobile only row">
                    <Menu.Menu position='left' style={{ marginRight: '0px !important', flexGrow: '2', display: 'flex' }}>
                        <Dropdown icon={null} trigger={<span style={{ whiteSpace: 'nowrap' }}><Icon link name='content' size='large' style={iconStyle} /></span>}>
                            {LeftDropdown(hasAdminPrivileges, true , helpFileLink, auth)}
                        </Dropdown>
                    </Menu.Menu>
                    <a className="header item"><img src={logoImg} id="nav-logo-2" alt='FYB CM2WebShare Logo' /></a>
                </Grid.Row>
            </Grid>
        </Menu>
    </div>
    );
}

export default NavMenuBasic;